
const DetailResponse = {
// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	"success": true,
	"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
	"token": "string",
	"busId": "string",
	"company": "string",
	"operatingCompany": {
		"code": "string",
		"name": "string"
	},
	"boardingPoint": {
		"city": "string",
		"terminal": "string",
		"additionalInfo": {
			"city": {
				"id": "string",
				"name": "string",
				"englishName": "string"
			},
			"name": "string",
			"englishName": "string"
		}
	},
	"droppingPoints": [
		{
			"city": "string",
			"terminal": "string",
			"additionalInfo": {
				"city": {
					"id": "string",
					"name": "string",
					"englishName": "string"
				},
				"name": "string",
				"englishName": "string"
			}
		}
	],
	"type": "string",
	"price": 0,
	"commissionPercentage": 0,
	"financial": {
		"price": 0,
		"maxApplicableDiscountPercentage": 0,
		"availablePaymentMethods": [
			"string"
		],
		"commissionPercentage": 0
	},
	"departureDate": "2023-05-07T08:35:04.486Z",
	"availableSeats": 0,
	"status": "string",
	"seates": [
		{
			"number": 0,
			"column": 0,
			"row": 0,
			"status": "string"
		}
	],
	"description": "string"
};
 

export default DetailResponse;
  